module.exports = __webpack_public_path__ + "static/media/post01.40311c71.jpg";